export function formatDateTime(iso: string | null, locale: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(d);
}

/**
 * Merchant-supplied redirect URLs are shown as a button. Only http(s) and same-origin paths are
 * allowed, so a crafted invoice cannot turn the button into a `javascript:` link.
 */
export function safeRedirect(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === "https:" || parsed.protocol === "http:" ? parsed.toString() : null;
  } catch {
    return null;
  }
}

/** First letter for the merchant monogram. */
export function monogram(name: string): string {
  const ch = name.trim().match(/[\p{L}\p{N}]/u)?.[0];
  return ch ? ch.toUpperCase() : "·";
}
